module.exports = __webpack_public_path__ + "static/media/pdf-download-image.afcba61a.jpg";